import classNames from 'classnames';
import PropTypes from 'prop-types';

const ChatSpacer = function ChatSpacer({
  author,
}) {
  return (
    <div className={classNames(
      'w-10 shrink-0',
      {
        'order-1': !author,
        'order-5': author,
      },
    )}
    />
  );
};

ChatSpacer.propTypes = {
  author: PropTypes.string,
};

export default ChatSpacer;
